// extracted by mini-css-extract-plugin
export default {"tile":"MerchStoreTile_tile__TaT9E","meta":"MerchStoreTile_meta__-OfGA"};